import { mapActions, mapGetters, mapMutations } from "vuex";

import { email, maxLength, required } from "vuelidate/lib/validators";
import { emailFormatter } from "@/mixins/validation";

import { VueTelInput } from "vue-tel-input";

export default {
    name: "popup-user-contacts-change",
    data() {
        return {
            payload: {
                email: "",
                phone: "",
            },
            isValidPhone: false,
            validationErrors: {
                phone: [],
            },
        };
    },
    props: {
        userContactsUpdate: {
            type: String,
            default: "phone",
        },
    },
    components: {
        VueTelInput,
    },
    validations() {
        if (this.userContactsUpdate === "email") {
            return {
                payload: {
                    email: {
                        required,
                        email: (val) => email(emailFormatter(val)),
                        maxLength: maxLength(50),
                    },
                },
            };
        }
    },
    computed: {
        ...mapGetters({
            showPopupUserContacts: "userContacts/showPopupUserContacts",
        }),
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(
                    this.$t("maxLengthField")
                        .replace(":field", this.$t("emailFieldShort"))
                        .replace(":count", 50)
                );
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            requestChangeContacts: "userContacts/SEND_REQUEST_CHANGE_CONTACTS",
        }),
        ...mapMutations({
            changeShowPopupContacts: "userContacts/POPUP_USER_CONTACTS_CHANGE",
        }),
        changePhoneInput(number, info) {
            this.isValidPhone = info.valid;
            if (this.isValidPhone) {
                this.payload.phone = info.number.e164.replace("+", "");
                console.log("this.payload.phone", this.payload.phone);
                this.validationErrors.phone = [];
            }
        },
        changeValidationPhone() {
            this.validationErrors.phone = [];
            if (this.payload.phone.length > 0) {
                if (!this.isValidPhone) {
                    this.validationErrors.phone.push(this.$t("enterCorrectPhone"));
                } else {
                    this.validationErrors.phone = [];
                }
            } else {
                this.validationErrors.phone.push(this.$t("validationRequired"));
            }
        },
        submit() {
            if (this.userContactsUpdate === "email") {
                this.$v.$touch();
                if (this.$v.$invalid) return;
            } else {
                this.changeValidationPhone();
                if (!this.isValidPhone) return;
            }
            this.requestChangeContacts({
                field: this.userContactsUpdate,
                value:
                    this.userContactsUpdate === "email"
                        ? this.payload.email
                        : this.payload.phone,
            }).then((response) => {
                if (response.data.data.field === "email") {
                    this.$toasted.success(this.$t("successRequestChangeEmail"));
                } else {
                    this.$toasted.success(this.$t("successRequestChangePhone"));
                }
            });
            if (this.userContactsUpdate === "email") {
                this.changeShowPopupContacts({ show: false, requestedEmail: true });
            } else {
                this.changeShowPopupContacts({ show: false, requestedPhone: true });
            }
        },
        closePopup() {
            this.changeShowPopupContacts({ show: false });
        },
    },
};
